import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";
import { LOGO } from "../../../config/config";

import {
  viewGeneralForm,
  saveGeneralResponse,
  saveGeneralResponseAsDraft,
} from "../../../config/forms_api_calls";
import FormRenderer from "../../../components/Reseller/formRender_response";
import NotificationToast from "../../../components/Notification/NotificationToast";
export default class UserForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form_token: "",
      form_title: "",
      form_desc: "",
      formAccNo: "",
      previewContent: [],
      form_submitted: "3",
      responseMessage: "",
      submission_status: "",
      allow_submit: 1,
      draftData: [],
      totalSteps: 0,
      progressStep: 0,
      allow_multiple: 0,
      formRenderKey: 0,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
    };
  }

  showToast = (message, type = "error", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: String(message || ""),
        toastType: type,
        toastTitle: title || (type === "success" ? "Success" : "Error"),
      }),
    );
  };

  async componentDidMount() {
    let form_token = this.props.match.params.form_token;
    this.setState({ form_token: form_token });
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });
    const servicesResponce = await viewGeneralForm(form_token);
    // console.log("previewForm: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
      this.setState({
        errorMessage: "The form was not found.",
        successMessage: "",
        disabled: false,
        form_submitted: 2,
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The form was not found.",
        successMessage: "",
        disabled: false,
        form_submitted: 2,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const form_data = servicesResponce.data.data[0]["form_content"]
        ? JSON.parse(servicesResponce.data.data[0]["form_content"])
        : [];
      const groupsData = servicesResponce.data.data[0]["groups"];
      const groups = groupsData ? JSON.parse(groupsData) : [];

      const draftResponse =
        servicesResponce.data.submission_data[0]["user_response"];
      const draftData =
        draftResponse && draftResponse !== "" ? JSON.parse(draftResponse) : [];
      const progress = servicesResponce.data.submission_data[0]["progress"];
      let progressStep = 0;
      if (progress) {
        const [current, total] = progress.split("/").map(Number);
        progressStep = current < total ? current : 0;
      }
      // Multiple-submission links are reset to a blank/editable template on the
      // server after each submit so the link stays reusable. If THIS browser
      // already submitted, keep showing the confirmation on refresh until the
      // user clicks "Submit Another Response".
      const backendSubmitted =
        servicesResponce.data.submission_data[0]["is_submitted"];
      const allowMultiple = servicesResponce.data.data[0]["allow_multiple"];
      const locallySubmitted =
        localStorage.getItem("uf_submitted_" + form_token) === "1";
      let form_submitted = backendSubmitted;
      let submission_status =
        servicesResponce.data.submission_data[0]["submission_status"];
      if (allowMultiple === 1 && backendSubmitted === 0 && locallySubmitted) {
        form_submitted = 1;
        submission_status = 0;
      }
      this.setState({
        form_token: form_token,
        formAccNo: servicesResponce.data.data[0]["form_accountno"],
        form_title: servicesResponce.data.data[0]["form_title"],
        form_desc: servicesResponce.data.data[0]["form_desc"],
        allow_submit: servicesResponce.data.data[0]["allow_submit"],
        form_submitted: form_submitted,
        submission_status: submission_status,
        form_data: form_data,
        groups: groups,
        draftData: draftData,
        totalSteps: groups.length,
        progressStep: progressStep,
        allow_multiple: servicesResponce.data.data[0]["allow_multiple"],
      });
    } else {
      this.setState({
        errorMessage: "There is some error while previewing the form.",
        successMessage: "",
        disabled: false,
        form_submitted: 2,
      });
    }
  }

  handleSaveDraft = (formData, currentStep) => {
    let response = JSON.stringify(formData);
    this.saveDraft(response, this.state.form_accountno, currentStep);
  };

  saveDraft = async (response, formAccNo, submittedStep) => {
    const { form_token, form_title, form_desc, totalSteps } = this.state;
    window.scrollTo({ top: 0, behavior: "smooth" });
    const submitFormReponse = await saveGeneralResponseAsDraft(
      response,
      formAccNo,
      form_token,
      form_title,
      form_desc,
      submittedStep,
      totalSteps,
    );
    // console.log("saveResponse response: ", submitFormReponse.data);
  };

  handleSubmitForm = (formData) => {
    //window.scrollTo({ top: 0, behavior: 'smooth' });
    //console.log("saveResponse formAccNo: ", this.state.formAccNo);
    //console.log("saveResponse formData: ", formData);
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.formAccNo);
  };

  saveResponse = async (response, formAccNo) => {
    //console.log("saveResponse response: ", response);
    window.scrollTo({ top: 0, behavior: "smooth" });
    const { form_token, form_title, form_desc, totalSteps } = this.state;

    try {
      const submitFormReponse = await saveGeneralResponse(
        response,
        formAccNo,
        form_token,
        form_title,
        form_desc,
        totalSteps,
      );
      const data = submitFormReponse?.data || {};

      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        return;
      }

      if (data.status === 200) {
        this.showToast(
          data.message || "Your response was submitted successfully!",
          "success",
          "Submitted",
        );
        // Show the confirmation ("Form Submitted") screen instead of reloading
        // back into the editable, pre-filled form. For multiple-submission
        // forms the confirmation offers a "Submit Another Response" action.
        // Remember submission locally so a refresh keeps the confirmation even
        // for multiple-submission links (which the server resets to reusable).
        if (this.state.form_token) {
          localStorage.setItem("uf_submitted_" + this.state.form_token, "1");
        }
        this.setState({
          responseMessage: "",
          form_submitted: 1,
          submission_status: 0,
          draftData: [],
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      const backendMessage =
        (typeof data.errors === "string" ? data.errors : data.errors?.message) ||
        data.message ||
        "There was an error while submitting the form.";
      this.setState({ responseMessage: "" });
      this.showToast(backendMessage, "error");
    } catch (error) {
      const resErrors = error?.response?.data?.errors;
      const backendMessage =
        (typeof resErrors === "string" ? resErrors : resErrors?.message) ||
        error?.response?.data?.message ||
        error?.message ||
        "There was an unexpected error while submitting the form.";
      this.showToast(backendMessage, "error");
    }

    setTimeout(() => {
      this.setState({
        errorMessageSaveResponse: "",
        responseMessage: "",
      });
    }, 10000);
  };

  // For multiple-submission forms: intentionally start a NEW, blank submission.
  submitAnotherResponse = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // Clear the local "already submitted" marker so the fresh form is shown
    // (and a mid-fill refresh keeps the editable form, the intended state).
    if (this.state.form_token) {
      localStorage.removeItem("uf_submitted_" + this.state.form_token);
    }
    this.setState((prevState) => ({
      form_submitted: 0,
      submission_status: "",
      draftData: [],
      progressStep: 0,
      responseMessage: "",
      formRenderKey: prevState.formRenderKey + 1,
    }));
  };

  render() {
    //console.log("this.state.form_submitted: ", this.state.form_submitted);
    return (
      <>
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div
          className="card-inner card-inner-lg form_main_container background-white"
          id="form_mainContainer"
        >
          <div className="d-flex justify-content-center mb-2">
            <img
              className="logo-dark"
              src={LOGO}
              alt="logo"
              style={{ height: "60px" }}
            />
          </div>
          {this.state.form_submitted === 0 ? (
            <div className="nk-block mt-4">
              <FormRenderer
                key={this.state.formRenderKey}
                formData={this.state.form_data}
                formTitle={this.state.form_title}
                formDescription={this.state.form_desc}
                groups={this.state.groups}
                onSubmit={this.handleSubmitForm}
                allow_submit={this.state.allow_submit}
                responseMessage={this.state.responseMessage}
                draftData={this.state.draftData}
                saveDraft={this.handleSaveDraft}
                progressStep={this.state.progressStep}
                onToast={this.showToast}
                // id={this.state.forms[0].id}
                // setShowResponse={(value) => this.setState({ showResponse: value })}
              />
            </div>
          ) : this.state.form_submitted === 1 &&
            this.state.submission_status === 2 ? (
            <div className="nk-block mt-4">
              <FormRenderer
                key={this.state.formRenderKey}
                formData={this.state.form_data}
                formTitle={this.state.form_title}
                formDescription={this.state.form_desc}
                groups={this.state.groups}
                onSubmit={this.handleSubmitForm}
                allow_submit={this.state.allow_submit}
                responseMessage={this.state.responseMessage}
                draftData={this.state.draftData}
                saveDraft={this.handleSaveDraft}
                progressStep={this.state.progressStep}
                onToast={this.showToast}
                // id={this.state.forms[0].id}
                // setShowResponse={(value) => this.setState({ showResponse: value })}
              />
            </div>
          ) : this.state.form_submitted === 1 &&
            this.state.submission_status === 1 ? (
            <div className="nk-block mt-4">
              <div className="nk-block-content nk-error-ld text-center">
                <h3 className="nk-error-title">Form Submitted</h3>
                <div className="alert alert-light alert-icon text-dark">
                  Your form has been submitted and approved. We have
                  successfully reviewed your information and appreciate the time
                  and effort you took to provide us with the necessary details.
                </div>
              </div>
            </div>
          ) : this.state.form_submitted === 1 &&
            this.state.submission_status === 0 ? (
            <div className="nk-block mt-4">
              <div className="nk-block-content nk-error-ld text-center">
                <h3 className="nk-error-title">Form Submitted</h3>
                <div className="alert alert-light alert-icon text-dark">
                 Your form has been submitted successfully and is currently under review. We will contact you if any additional information is needed.
                </div>
                {this.state.allow_multiple === 1 ? (
                  <center>
                    <a
                      onClick={this.submitAnotherResponse}
                      className="btn btn-primary mt-2"
                      style={{ color: "#fff", cursor: "pointer" }}
                    >
                      Submit Another Response
                    </a>
                  </center>
                ) : null}
              </div>
            </div>
          ) : this.state.form_submitted === 2 ? (
            <div className="nk-block mt-4">
              <div className="nk-block-content nk-error-ld text-center">
                <h1 className="nk-error-head">404</h1>
                <h3 className="nk-error-title">Form Unavailable</h3>
                <p className="nk-error-text">
                  We are very sorry for inconvenience. It looks like you’re try
                  to access a form that either has been expired or already
                  submitted.
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  }
}
